module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori@3x-9407fbc6d7d5b5d5ee79d6716be9ce0d.webp";